export default __webpack_public_path__ + "media/images/paylogos/color/dotpay@2x-404f685ef4669f9fb2ab1489df16743f.png";